import { PlanGroupIds } from '../../../constants/planGroupIds';
import { isSmsMarketAddOnId } from '../../../utils/smsAddOnUtils';

const GB_PLAN_GROUP_IDS = [PlanGroupIds.GREAT_BRITAIN_V1, PlanGroupIds.GREAT_BRITAIN_LEAD_MAGNET];

export { SMS_MARKET_ADDON_ID_PREFIX } from '../../../utils/smsAddOnUtils';

interface CatalogAddOn {
  id?: string;
}

export const isSmsAddonInCatalog = (addOns: CatalogAddOn[] | null | undefined): boolean =>
  // Geo getAddOns is not filtered by market id; any `CTCT-SMS-ADDON*` entry means SMS is in catalog.
  (addOns ?? []).some((addOn) => isSmsMarketAddOnId(addOn.id));

interface CustomerLocationParams {
  planGroupId?: number;
  countryCode?: string;
}

export const getIsAuCustomer = ({ planGroupId, countryCode }: CustomerLocationParams): boolean =>
  planGroupId === PlanGroupIds.AUSTRALIA_V1 || countryCode?.toUpperCase() === 'AU';

export const getIsGbCustomer = ({ planGroupId, countryCode }: CustomerLocationParams): boolean =>
  (planGroupId != null && GB_PLAN_GROUP_IDS.includes(planGroupId)) || countryCode?.toUpperCase() === 'GB';

interface SmsVisibilityParams {
  isSmsEligible: boolean;
  smsAddonAvailable: boolean;
  isEligibilityLoading?: boolean;
  eligibilityCheckFailed?: boolean;
}

/**
 * Hide SMS when the catalog has no SMS add-on. Eligibility only hides SMS after a definitive
 * ineligible response — not while loading or when the eligibility endpoint errors.
 */
export const getHideSmsInfo = ({
  isSmsEligible,
  smsAddonAvailable,
  isEligibilityLoading = false,
  eligibilityCheckFailed = false,
}: SmsVisibilityParams): boolean => {
  if (!smsAddonAvailable) {
    return true;
  }

  if (isEligibilityLoading || eligibilityCheckFailed) {
    return false;
  }

  return !isSmsEligible;
};
